import ConfirmDialog from './ConfirmDialog.vue';

export default {
  install(Vue) {
    Vue.component('ConfirmDialog', ConfirmDialog);
    Vue.mixin({
      methods: {
        showConfirm(msg, title = '') {
          this.$root.$emit('show-confirm', { title, msg });
          return new Promise((resolve, reject) => {
            this.$root.$on('hide-confirm', (resolution) => {
              if (resolution === 'accept') {
                resolve(resolution);
              } else {
                reject(resolution);
              }
              this.$root.$off('hide-confirm');
            });
          });
        },
      },
    });
  },
};
